import React from 'react';
import ExpenseCard from './ExpenseCard';
import LoadingSpinner from '../common/LoadingSpinner';
import { Expense } from '../../types/expense';

interface ExpenseListProps {
  expenses: Expense[];
  loading: boolean;
  onEdit: (expense: Expense) => void;
  onSync?: (expense: Expense) => void;
  syncingExpenseId?: string | null;
  updatingExpenseId?: string | null; // New prop for update indicator
}

const ExpenseList: React.FC<ExpenseListProps> = ({ expenses, loading, onEdit, onSync, syncingExpenseId, updatingExpenseId }) => {
  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!expenses || expenses.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">Расходы не найдены</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {expenses.map((expense) => (
        <ExpenseCard
          key={expense.expense_id}
          expense={expense}
          onEdit={onEdit}
          onSync={onSync}
          isSyncing={syncingExpenseId === expense.expense_id}
          isUpdating={updatingExpenseId === expense.expense_id}
        />
      ))}
    </div>
  );
};

export default ExpenseList;
